import React from 'react'
import SectionTitle from '../../components/SectionTitle/SectionTitle'
import Gallarysection from './Gallarysection'
import DriveEmbedGallery from './DriveEmbedGallery'

export default function Gallary() {
  return (
    <>
    <SectionTitle title="Our Gallary" />
    <DriveEmbedGallery />
    {/* <Gallarysection /> */}
    
    </>
  )
}
